import { ApproversListResult } from 'api/services/Admin';
import { UserRoles } from 'components/Auth/AuthProvider';

function base64ToBlob(base64String: string): Blob {
  const byteString = window.atob(base64String);
  const bytes = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }

  return new Blob([bytes], { type: 'application/octet-stream' });
}

export function downloadFileFromBase64(
  base64String: string | undefined,
  filename: string | undefined
): void {
  if (base64String && filename) {
    const blob = base64ToBlob(base64String);
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
  }
}
